import { cdmMw } from "../api";

export const broadcastMessageResource = {
    api: cdmMw,
    url: () => '/api/createMessage',
    parseResponse: ({data}) => data,
    defaultValue: []
};